import { render } from "./HotelHeaderLite.vue?vue&type=template&id=4b77080b"
import script from "./HotelHeaderLite.vue?vue&type=script&lang=js"
export * from "./HotelHeaderLite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__